import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import referralBackgroundImage from '../../../assets/images/home-dashboard-referral-background.png';
import { zIndexMap } from '../../../shared/config';
import { PrimaryButton } from '../../../shared/ui';

const Card = styled.section.attrs({
  'data-ui': 'home-dashboard-referral-card',
})`
  position: relative;
  min-height: ${({ theme }) => theme.scale.px(164)};
  border-radius: ${({ theme }) => theme.scale.px(12)};
  padding: ${({ theme }) => theme.scale.px(17)}
    ${({ theme }) => theme.scale.px(14)} ${({ theme }) => theme.scale.px(15)};
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.surface.base};
  overflow: hidden;
  display: grid;
  grid-template-rows: auto 1fr auto;
  row-gap: ${({ theme }) => theme.scale.px(15)};
`;

const Content = styled.div`
  grid-row: 1;
  position: relative;
  z-index: ${zIndexMap.homeDashboard.referralForeground};
  display: grid;
  gap: ${({ theme }) => theme.scale.px(6)};
`;

const Title = styled.h2`
  margin: 0;
  max-width: ${({ theme }) => theme.scale.px(220)};
  font-size: ${({ theme }) => theme.scale.px(16)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(19)};
`;

const Description = styled.p`
  margin: 0;
  max-width: ${({ theme }) => theme.scale.px(209)};
  font-size: ${({ theme }) => theme.scale.px(12)};
  line-height: ${({ theme }) => theme.scale.px(14)};
`;

const BackgroundImage = styled.img.attrs({
  alt: '',
  'aria-hidden': true,
})`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  z-index: ${zIndexMap.homeDashboard.referralBackground};
`;

const ParticipateButton = styled(PrimaryButton).attrs({
  'data-ui': 'home-dashboard-referral-button',
})`
  grid-row: 3;
  position: relative;
  z-index: ${zIndexMap.homeDashboard.referralForeground};
  width: 100%;
  min-height: ${({ theme }) => theme.scale.px(35)};
  border-radius: ${({ theme }) => theme.scale.px(12)};
`;

type HomeDashboardReferralCardProps = {
  onOpenReferral?: () => void;
};

export function HomeDashboardReferralCard({
  onOpenReferral,
}: HomeDashboardReferralCardProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <BackgroundImage src={referralBackgroundImage} />
      <Content>
        <Title>{t('homeDashboard.referralTitle')}</Title>
        <Description>{t('homeDashboard.referralDescription')}</Description>
      </Content>
      <ParticipateButton type="button" onClick={onOpenReferral}>
        {t('homeDashboard.participate')}
      </ParticipateButton>
    </Card>
  );
}
